import { i18n } from '/business/shared/translations/i18n';

import { questionBuilder } from '/business/shared/components/questions/helper/questionBuilder';
import { getQuestionBuildingOtherFuels } from '/business/shared/components/questions/scope1/_config/getConfigureOtherFuels';
import { getConfigureRefrigerants } from '/business/shared/components/questions/scope1/_config/getConfigureRefrigerants';
import { getConfigureCompanyVehicles } from '/business/shared/components/questions/scope1/companyVeh/_config/getConfigureCompanyVehicles';
import { getConfigureEvCharging } from '/business/shared/components/questions/scope2/_config/getConfigureEvCharging';
import { getQuestionDownstreamLeasedBuildings } from '/business/shared/components/questions/scope3/_config/getConfigureDownstreamLeasedBuildings';
import { getConfigurePhantomFuelAndEnergy } from '/business/shared/components/questions/scope3/_config/getConfigurePhantomFuelAndEnergy';
import { getConfigureWasteGeneratedInOps } from '/business/shared/components/questions/scope3/_config/getConfigureWasteGeneratedInOps';
import { getQuestionBusinessTravel } from '/business/shared/components/questions/scope3/businessTravel/_config/getConfigureBusinessTravelSection';
import { getConfigureDownstreamLeasedVehicles } from '/business/shared/components/questions/scope3/downstreamLeasedVehicles/_config/getConfigureDownstreamLeasedVehicles';
import { getConfigureEmployeeCommutes } from '/business/shared/components/questions/scope3/employeeCommutes/_config/getConfigureEmployeeCommutes';
import { getConfigureSoldProducts } from '/business/shared/components/questions/scope3/soldProducts/_config/getConfigureSoldProducts';
import { getConfigureDownstreamTransportationAndDistribution } from '/business/shared/components/questions/scope3/transportAndDistribution/downstream/_config/getConfigureDownstreamTransportationAndDistribution';
import { getConfigureUpstreamTransportationAndDistribution } from '/business/shared/components/questions/scope3/transportAndDistribution/upstream/_config/getConfigureUpstreamTransportationAndDistribution';
import { getConfigureUpstreamLeasedBuildings } from '/business/shared/components/questions/scope3/upstreamBuildings/_config/getConfigureUpstreamLeasedBuildings';
import { getConfigureCapitalGoods } from '/business/shared/components/questions/scope3/goods/capitalGoods/_config/getConfigureCapitalGoodsAndServices';
import { getConfigurePurchasedGoodsAndServices } from '/business/shared/components/questions/scope3/goods/purchasedGoods/_config/getConfigurePurchasedGoodsAndServices';
import { getConfigureElectricityHeatSteam } from '/business/shared/components/questions/scope2/_config/getConfigureElectricityHeatSteam';

export const getQuestionsLookup = () => {
  const isScopeBased = true;
  const buildingRefrigerants = getConfigureRefrigerants({
    i18n,
    hasScopeBasedOrganisation: isScopeBased,
  });
  const buildingOtherFuels = getQuestionBuildingOtherFuels({
    i18n,
    hasScopeBasedOrganisation: isScopeBased,
  });
  const travelVehicles = getConfigureCompanyVehicles({
    i18n,
    hasScopeBasedOrganisation: isScopeBased,
  });
  const phantomFuelAndEnergy = getConfigurePhantomFuelAndEnergy({
    i18n,
  });
  const businessTravel = getQuestionBusinessTravel({
    i18n,
    hasScopeBasedOrganisation: isScopeBased,
  });
  const downstreamLeasedBuildings = getQuestionDownstreamLeasedBuildings({
    i18n,
    hasScopeBasedOrganisation: isScopeBased,
  });
  const wasteGeneratedInOps = getConfigureWasteGeneratedInOps({
    i18n,
    hasScopeBasedOrganisation: isScopeBased,
  });
  const travelEmployeeCommutes = getConfigureEmployeeCommutes({
    i18n,
    hasScopeBasedOrganisation: isScopeBased,
  });
  const evCharging = getConfigureEvCharging({
    i18n,
  });
  const purchasedGoodsAndServices = getConfigurePurchasedGoodsAndServices({ i18n });
  const capitalGoods = getConfigureCapitalGoods({ i18n });
  const soldProducts = getConfigureSoldProducts({ i18n });
  const upstreamLeasedBuildings = getConfigureUpstreamLeasedBuildings({ i18n });
  const upstreamTransportationAndDistribution = getConfigureUpstreamTransportationAndDistribution({ i18n });
  const downstreamTransportationAndDistribution = getConfigureDownstreamTransportationAndDistribution({ i18n });
  const downstreamLeasedVehicles = getConfigureDownstreamLeasedVehicles({ i18n });

  const electricityHeatSteam = getConfigureElectricityHeatSteam({ i18n });
  return questionBuilder({
    questions: [
      buildingOtherFuels,
      buildingRefrigerants,
      travelVehicles,

      purchasedGoodsAndServices,
      capitalGoods,
      phantomFuelAndEnergy,
      upstreamTransportationAndDistribution,
      wasteGeneratedInOps,
      businessTravel,
      travelEmployeeCommutes,
      upstreamLeasedBuildings,
      downstreamTransportationAndDistribution,
      soldProducts,
      downstreamLeasedBuildings,
      downstreamLeasedVehicles,

      electricityHeatSteam,
      evCharging,
    ],
  });
};
